import { render, staticRenderFns } from "./FAQsList.vue?vue&type=template&id=34991ce0&scoped=true"
import script from "./FAQsList.vue?vue&type=script&lang=js"
export * from "./FAQsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34991ce0",
  null
  
)

export default component.exports